export const secret_key = "ab24964ce5d0646a2d67c31f1689b68cdbdc5f25"
export const public_key = "21e5b9bc433f64a9b3867efbc478154a"
